import { BlButton } from "Components/Shared/Buttons/BlButton";
import { getApiUrl, getCutoffsAdvisorOverviewsAccountantDescriptionFilePath } from "Api/Api";
import { Resources, useResource } from "Translations/Resources";
import { useState } from "react";

export const DownloadAccountantDescriptionButton: React.FunctionComponent = () => {
  const { t } = useResource();
  const [isLoading, setIsLoading] = useState(false);

  const handleDownload = async () => {
    setIsLoading(true);
    try {
      const url = `${getApiUrl()}${getCutoffsAdvisorOverviewsAccountantDescriptionFilePath()}`;

      const response = await fetch(url, {
        method: "GET",
      });

      if (response.ok) {
        const blob = await response.blob();
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.download = "Popis_placeneho_poradenstvi.pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
      }
    } catch (error) {
      console.error("Failed to download accountant description", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <BlButton isLoading={isLoading} onClick={handleDownload}>
      {t(Resources.Settings.Cutoff.AdvisorOverview.AccountantDescription.Button)}
    </BlButton>
  );
};
